module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/section04_06_american-village-b1c43ba508700a7d1f695e1cf9ffc5cd.jpg";